export const productsWithDisplayKey = (products: any) => {
    return products.map((product: any) => ({
        ...product,
        displayKey: `[${product.ref}] ${product.name} (stock${
            product.quantity > 0 ? `: ${product.quantity}` : ' épuisé'
        })`,
    }));
};
